import { render, staticRenderFns } from "./SpFooterComponent.vue?vue&type=template&id=c7b4af7a&scoped=true&"
import script from "./SpFooterComponent.vue?vue&type=script&lang=js&"
export * from "./SpFooterComponent.vue?vue&type=script&lang=js&"
import style0 from "./SpFooterComponent.vue?vue&type=style&index=0&id=c7b4af7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b4af7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7b4af7a')) {
      api.createRecord('c7b4af7a', component.options)
    } else {
      api.reload('c7b4af7a', component.options)
    }
    module.hot.accept("./SpFooterComponent.vue?vue&type=template&id=c7b4af7a&scoped=true&", function () {
      api.rerender('c7b4af7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/commons/SpFooterComponent.vue"
export default component.exports